

var ENVIRONMENT;

ENVIRONMENT = {
  REST: "https://dev.ffetoll.idfcfirstbank.com/etollff",
};

// Assign the exact Environment Variable from above List to BASEURL
export const REST_BASEURL = ENVIRONMENT.REST;
   
export const APIURL = {
  VERIFY: `${REST_BASEURL}/applynow/verify`,
  VERIFY_ENC: `${REST_BASEURL}/applynow/encrypted/v3/verify`,
  GET_DETAILS_BY_REQID_ENC: `${REST_BASEURL}/applynow/encrypted/v3/getdtlsbyreqid`,
  IS_COMM_VEH: `${REST_BASEURL}/applynow/setCommVehicle`,
  LOGIN: `${REST_BASEURL}/login`,
  VALIDATE_OTP: `${REST_BASEURL}/login/validateOTP`,
  VALIDATE_OTP_LOGIN: `${REST_BASEURL}/login/validateLoginByOTP`,
  VALIDATE_OTP_APPLYNOW: `${REST_BASEURL}/utility/validateOTP`,
  SEND_OTP: `${REST_BASEURL}/utility/sendotp`,
  FORCE_LOGIN: `${REST_BASEURL}/login/forceLogin`,
  FORGOT_PSWD: `${REST_BASEURL}/login/v1/forgotPassword`,
  UNLOCK_USER: `${REST_BASEURL}/unlockUser`,
  GET_ENC_KEY: `${REST_BASEURL}/login/getEncKey`,
  PRICE_BREAKUP: `${REST_BASEURL}/applynow/getFasTagPriceBreakUp`,
  LOGOUT: `${REST_BASEURL}/logoutUser`,
  DOWNLOAD_STMT_HISTORY_EXCEL: `${REST_BASEURL}/statement/getDownloadStatement`,
  DOWNLOAD_STMT: `${REST_BASEURL}/statement/downloadOrEmail`,
  DOWNLOAD_STMT_HISTORY: `${REST_BASEURL}/statement/historyStatementRequest`,
  GET_PAYMENT_DATA: `${REST_BASEURL}/payment/v4/initilizePayment`,
  GET_PAYMENT_STATUS: `${REST_BASEURL}/payment/v4/getPaymentStatus`,
  GET_DETAILS_BY_REQID: `${REST_BASEURL}/applynow/getdtlsbyreqid`,
  GET_VEHICLE_CLASS: `${REST_BASEURL}/applynow/getVcClasses`,
  GET_STATEMENTS: `${REST_BASEURL}/statement/v4/statements`,
  GET_STATEMENTS_DOWNLOAD_STATUS: `${REST_BASEURL}/statement/getDownloadStatementStatus`,
  STATEMENT_FILTER_V4: `${REST_BASEURL}/statement/v4/statements-filter-pagination`,
  STATEMENT_FILTER: `${REST_BASEURL}/statement/getFilteredStatements`,
  STATEMENT_BY_VRN:`${REST_BASEURL}/statement/v4/statements-by-vrn-pagination`,
  EXPENSE_STATS: `${REST_BASEURL}/dashboard/expense-stats`,
  EXPENSE_STATS_BY_DATE: `${REST_BASEURL}/dashboard/expense-stats-by-date`,
  WALLET_BAL: `${REST_BASEURL}/dashboard/wallet-balance`,
  GET_OFFERS:`${REST_BASEURL}/offers`,
  GET_PROFILE_DETAILS:`${REST_BASEURL}/utility/profile-details-new`,
  GET_ALL_VEHICLES_FOR_USER:`${REST_BASEURL}/vehicles/all-vehicles-for-user`,
  GET_ALL_VEHICLES_FOR_USER_V2 :`${REST_BASEURL}/vehicles/getAllVehicleForStmt`,
  GET_ALL_VEHICLES_FOR_NPCI_CLOSED : `${REST_BASEURL}/vehicles/allNpciClosedVehicles` , 
  DASHBOARD_VEHICLE_DETAILS:`${REST_BASEURL}/vehicles/dashboard-vehicle-details`,
  GET_DASHBOARD_FASTAGS:`${REST_BASEURL}/fastag/fastags`,
  // GET_VEHICLE_BY_TXN_ID:`${REST_BASEURL}/vehicles/v2/vehicle-by-txn-id`,
  SEARCH_VEHICLE:`${REST_BASEURL}/vehicles/filter-vehicles`,
  GET_CORPORATE_USER_DETAILS : `${REST_BASEURL}/utility/profile-details-corporate-customer`,
  GET_PROFILE_IMAGE : `${REST_BASEURL}/utility/profileImage`,
  UPDATE_PROFILE_IMAGE : `${REST_BASEURL}/utility/uploadProfileImage`,
  GET_POOL_ACCOUNT_DETAILS:`${REST_BASEURL}/poolAccount/getPoolAccountDtls`,
  GET_ENABLE_AUTOPAY_POOL_ACCOUNT:`${REST_BASEURL}/autopay/enable`,
  GET_DISABLE_AUTOPAY_POOL_ACCOUNT:`${REST_BASEURL}/autopay/disable`,
  GET_POOL_TO_TAG:`${REST_BASEURL}/poolTransfer/v2/poolToTagTrans/bulk`,
  GET_TAG_TO_POOL:`${REST_BASEURL}/poolTransfer/v2/tagToPool`, 
  POST_TAG_TO_TAG_REQ:`${REST_BASEURL}/poolTransfer/v2/tagToTagTransReq`,
  POST_TAG_TO_TAG_PROC:`${REST_BASEURL}/poolTransfer/tagTotagTransProc`,
  VERIFY_SERVICE: `${REST_BASEURL}/service/v4/verifyKycDoc`,
  GET_SERVICE_REQ:`${REST_BASEURL}/service/get-service-requests`,
  CHANGE_ADDRESS: `${REST_BASEURL}/applynow/changeAddress`,
  CERDIT_CARD_DETAILS: `${REST_BASEURL}/credit/credit-card-dtls`,
  AUTO_RECHARGE_DETAILS: `${REST_BASEURL}/credit/user-auto-recharge-dtls`,
  UPDATE_AUTO_RECHARGE_STATUS: `${REST_BASEURL}/credit/updateAutoRechargeStatus`,
  CAPTCHA : `${REST_BASEURL}/captcha`,
  GET_KYC_STATUS:`${REST_BASEURL}/service/kycStatus`,
  VERIFY_RC_UPDATE : `${REST_BASEURL}/applynow/encrypted/rcupdate/verify`,
  RC_UPDATE_SERVICE_REQUEST : `${REST_BASEURL}/applynow/encrypted/rcupdate/servicerequest`,
  RC_UPDATE : `${REST_BASEURL}/applynow/encrypted/rcupdate`,
  PAN_VALIDATION : `${REST_BASEURL}/onboard/v2/panValidation`,
  FUEL_SEND_OTP : `${REST_BASEURL}/onboard/fuel/reqotp`,
  FUEL_VALIDATE_OTP : `${REST_BASEURL}/onboard/fuel/optInOrOptOut/kycUpdate`,
  INITIATE_VERIFICATION : `${REST_BASEURL}/onboard/initiateVerification`,
  GET_DIGI_LOCKER_STATUS : `${REST_BASEURL}/onboard/kyc/statusAndDetails`,
  GET_FUEL_KYC_STATUS : `${REST_BASEURL}/onboard/isCustDigitalKyc`,
  VALIDATELOGINVRNOTP : `${REST_BASEURL}/login/validateLoginVrnOTP`,
  DIGILOCKER_CONFIG : `${REST_BASEURL}/utility/digilockerTimeDuration`,
  GET_FAQS:`${REST_BASEURL}/faq`,
  TNC: `${REST_BASEURL}/getTermsAndCondition`,
  TNC_V1 : `${REST_BASEURL}/getTnc`,
  APPLY_LOAN : `${REST_BASEURL}/usedCarLoan/createLoan`,
  GET_CUST_INFO : `${REST_BASEURL}/usedCarLoan/custInfo`,
  UPDATE_LOAN : `${REST_BASEURL}/usedCarLoan/updateLoan`,
  GET_STATE_LIST : `${REST_BASEURL}/usedCarLoan/states`,
  GET_CITY_LIST : `${REST_BASEURL}/usedCarLoan/locations`,
  GET_EMPLOYER_INFO : `${REST_BASEURL}/usedCarLoan/employerInfo/master`,
  GET_ALL_APPLICATIONS : `${REST_BASEURL}/usedCarLoan/allApplicationId`,
  GET_APPLICATION_STATUS : `${REST_BASEURL}/usedCarLoan/loanStatus`,
  GET_VEHICLE_BRAND_INFO : `${REST_BASEURL}/usedCarLoan/vehicleInfo/master`,
  GET_STATE_LIST_SERVICE : `${REST_BASEURL}/service/getStateName`,
  GET_CITY_LIST_SERVICE : `${REST_BASEURL}/service/getCityName`,
  GET_ACTIVE_PLANS : `${REST_BASEURL}/trip/insurance/activePlan`,
  POST_POLICY_ISSUANCE: `${REST_BASEURL}/trip/insurance/policy/issuance`,
  POST_POLICY_CANCELLATION: `${REST_BASEURL}/trip/insurance/policy/cancellation`,
  POST_POLICY_SAVE_NOMINEE: `${REST_BASEURL}/trip/insurance/saveNominee`,
  GET_CONFIGURATIONS : `${REST_BASEURL}/getConfigData`,   
  POST_HIT_BANNER : `${REST_BASEURL}/banner/hitDtls/save`,
  TI_GET_CITY_STATE :`${REST_BASEURL}/trip/insurance/address`,
  TI_GET_POLICY_DETAILS :`${REST_BASEURL}/trip/insurance/customer/policydetails`, 
  TI_GET_NOMINEE_RELATION : `${REST_BASEURL}/trip/insurance/nomineeRelationships`, 
  UPDATE_MOBILENUMBER:`${REST_BASEURL}/customerV3/digital/update/mobile`,
  UPDATE_EMAIL:`${REST_BASEURL}/customerV3/digital/update/emailId`,
  GET_UPDATE_STATUS:`${REST_BASEURL}/customerV3/getStatus`,
  UPDATE_MOBILENUMBER:`${REST_BASEURL}/customerV3/digital/update/mobile`,
  UPDATE_KYC:`${REST_BASEURL}/customerV3/v2/digital/updateKyc`,
  UPDATE_EMAIL:`${REST_BASEURL}/customerV3/digital/update/emailId`,
  GET_TRIP_TRANSACTIONS: `${REST_BASEURL}/trip/insurance/trip-statements`,
  DOWNLOAD_TRIP_INSURANCE_CERTIFICATE: `${REST_BASEURL}/trip/insurance/downloadStarHealthPolicyDocument?coiNumber=`,
  TRIP_RAISE_DISPUTE: `${REST_BASEURL}/trip/insurance/TripRaiseDispute`,
  TRIP_DISPUTE_STATMENT: `${REST_BASEURL}/trip/insurance/trip-disputes-statement`,
  TRIP_DISPUTE_HISTORY: `${REST_BASEURL}/trip/insurance/trip-disputes-history`,
  TRIP_DISPUTE_DROPDOWN: `${REST_BASEURL}/trip/insurance/trip-dispute-page-dropdown`,
  TRIP_DISPUTE_COUNT: `${REST_BASEURL}/trip/insurance/trip-dispute-count`,
  TRIP_DISPUTE_FILTER: `${REST_BASEURL}/trip/dispute/trip-disputes-by-filter`,
  TRIP_DISPUTE_BY_TXN_NO: `${REST_BASEURL}/trip/dispute/trip-disputes-by-txn-no`,
  CLOSURE_TAG:`${REST_BASEURL}/tagClosure/v2/closeTagOnline`,
  SHOW_CONFIG_TO_USER: `${REST_BASEURL}/config/showConfigToUser`,
  RAISE_DISPUTE: `${REST_BASEURL}/dispute/createDispute`,
  DISPUTE_COUNT: `${REST_BASEURL}/dispute/dispute-count`,
  DISPUTE_DROPDOWN: `${REST_BASEURL}/dispute/v2/dispute-page-dropdown`,
  // DISPUTE_HISTORY: `${REST_BASEURL}/dispute/v2/disputes-history`,
  DISPUTE_HISTORY: `${REST_BASEURL}/dispute/fetch-disputes-history`,
  DISPUTE_LIST: `${REST_BASEURL}/dispute/disputes-statement`,
  DISPUTE_FILTER: `${REST_BASEURL}/dispute/disputes-by-filter`,
  DISPUTE_BY_TXN_NO: `${REST_BASEURL}/dispute/disputes-by-txn-no`,
  // DISPUTE_STATEMENT:`${REST_BASEURL}/dispute/v2/all-toll-disputes`,
  CLOSURE_TAG_VEHICLES:`${REST_BASEURL}/tagClosure/allCloseTagVehicles`,
  CLOSURE_TAG_REFUND_CHECK:`${REST_BASEURL}/tagClosure/tagClosureRefundCheck`,
  GET_MAX_PRO_FAQ: `${REST_BASEURL}/v1/getFAQ`,
  MAX_PRO_OPT_IN: `${REST_BASEURL}/fastag/v2/pro/opt`,
  MAX_PRO_OPT_OUT: `${REST_BASEURL}/fastag/pro/opt/out`,
  GET_ALL_VEHICLES_MAX_PRO_ENABLED:`${REST_BASEURL}/vehicles/all-maxpro-enabled`,
  FILTERED_DISPUTE:`${REST_BASEURL}/dispute/filtered-transactions`,
  FUEL_TRANSACTION_HISTORY:`${REST_BASEURL}/hpfuelPayment/getFulePmtTransactionHistory`,
  TRIP_INSURANCE_AUTO_RENEWAL_OPT_OUT:`${REST_BASEURL}/trip/insurance/annualInsuranceOptOut`,
  TAG_CLOSURE_FILTER_VRN:`${REST_BASEURL}/tagClosure/closeTagVrnFilter`,
  GET_ALL_VEHICLES_FOR_KYV_PENDING : `${REST_BASEURL}/vehicles/allKyvPendingVehicles` , 
};

